import { useLocation } from "react-router-dom";
import ErrorBoundary from "./ErrorBoundary";

const LocationAwareErrorBoundary = ({ children }: { children: React.ReactNode }) => {
  const location = useLocation();
  return <ErrorBoundary locationKey={location.key}>{children}</ErrorBoundary>;
};

export default LocationAwareErrorBoundary;
